console.log('🚀 carousel.js booted');

document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.product-card__media-wrapper');

  wrappers.forEach((wrapper, i) => {
    const img = wrapper.querySelector('.js-carousel-image');
    const prev = wrapper.querySelector('.js-carousel-prev');
    const next = wrapper.querySelector('.js-carousel-next');

    if (!img || !prev || !next) return;

    let images;
    try {
      images = JSON.parse(img.getAttribute('data-images').replace(/&quot;/g, '"'));
    } catch (e) {
      console.error(`🧨 JSON parse error in product #${i}:`, e);
      return;
    }

    if (!images || images.length < 1) return;

    let idx = 0;

    wrapper.addEventListener('mouseenter', () => {
      if (images.length > 1) {
        img.src = images[1];
        idx = 1;
      }
    });

    wrapper.addEventListener('mouseleave', () => {
      img.src = images[0];
      idx = 0;
    });

    prev.addEventListener('click', (e) => {
      e.preventDefault();
      idx = (idx - 1 + images.length) % images.length;
      img.src = images[idx];
    });

    next.addEventListener('click', (e) => {
      e.preventDefault();
      idx = (idx + 1) % images.length;
      img.src = images[idx];
    });
  });
});
